export class DataBodyRequest {
    public data: any;
    public operationId: number = 1;
    public metadata?: Metadata;

}

interface IBuilder {
    buildData(data: any): this
    buildOperationId(operationId: number): this
    buildMetaData(metadata: any): this
    getResult(): DataBodyRequest
}

export class Metadata {
    accuracy: number
    deviceInfo: string
    latitude: number
    longitude: number
    timeZoneId: number
    userId: number
}

export class DataBuilder implements IBuilder {
    // The Concrete Builder
    dataRequest: DataBodyRequest

    constructor() {
        this.dataRequest = new DataBodyRequest()
    }

    buildData(data: any) {
        this.dataRequest.data = data
        return this
    }

    buildOperationId(operationId: number) {
        this.dataRequest.operationId = operationId
        return this
    }

    buildMetaData(metadata: Metadata) {
        this.dataRequest.metadata = metadata
        return this
    }

    getResult() {
        return this.dataRequest
    }
}
